import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useTranslation } from 'language/translator'
import * as UserEvents from 'redux/api/internal/UserEvents'
import { Action } from 'types/GlobalUserEvents'
import { getContext } from 'utils/userEvents'

import AnalysesTable from 'components_new/organisms/analyses/AnalysesTable'

import PageLayout from 'components_new/templates/PageLayout'

const Analyses = () => {
  const { t } = useTranslation()
  const { search } = useLocation()

  useEffect(() => {
    UserEvents.log({
      action: Action.INSIGHTS_OPENED,
      context: getContext(new URLSearchParams(search)),
      analysis_id: null
    })
  }, [])

  return (
    <PageLayout
      topbar={{
        breadcrumbs: [
          {
            href: '/analyses',
            icon: { name: 'Analyses' },
            title: t('analyses', 'analyses')
          }
        ],
        mobile: {
          goBack: true
        }
      }}
      variant="static"
    >
      <AnalysesTable enableSearch={true} sx={{ flex: 1 }} />
    </PageLayout>
  )
}

export default Analyses
